/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Alternatives_Browse_CategoryInputs */

const en_directory_alternatives_browse_category = /** @type {(inputs: Directory_Alternatives_Browse_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse category`)
};

const zh_directory_alternatives_browse_category = /** @type {(inputs: Directory_Alternatives_Browse_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浏览分类`)
};

/**
* | output |
* | --- |
* | "Browse category" |
*
* @param {Directory_Alternatives_Browse_CategoryInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_alternatives_browse_category = /** @type {((inputs?: Directory_Alternatives_Browse_CategoryInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Alternatives_Browse_CategoryInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_alternatives_browse_category(inputs)
	return zh_directory_alternatives_browse_category(inputs)
});
export { directory_alternatives_browse_category as "directory.alternatives.browse_category" }